import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCALHOST_API : process.env.REACT_APP_PRODUCTION_API
});

